/**
 * Shared copy for Affiliate Portal access denial.
 * Keep wording careful: do not assert wrongdoing; reference terms/policies review.
 */

export const AFFILIATE_PORTAL_BLOCKED_CODE = "affiliate_portal_blocked";

export const AFFILIATE_PORTAL_BLOCKED_MESSAGE =
  "Access to the Affiliate Portal is currently unavailable for this account. " +
  "This may be related to a review of the account's compliance with the Affiliate " +
  "Program Terms of Use and applicable policies. If you believe this determination " +
  "was made in error, please contact support for further information. " +
  "MyVitae reserves the right to restrict portal access as described in the " +
  "Affiliate Program Terms.";

export const isAffiliatePortalBlockedError = (errorOrData) => {
  const code = errorOrData?.data?.code || errorOrData?.code;
  return code === AFFILIATE_PORTAL_BLOCKED_CODE;
};

export const getAffiliatePortalBlockedMessage = (errorOrData) => {
  const fromApi = errorOrData?.data?.error || errorOrData?.error;
  if (typeof fromApi === "string" && fromApi.trim()) return fromApi.trim();
  return AFFILIATE_PORTAL_BLOCKED_MESSAGE;
};
